import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import apiService from '../services/api';

interface SchedulerStatus {
  is_running: boolean;
  next_run: string | null;
  jobs_count: number;
}

export const useScheduler = () => {
  const { trainer } = useAuth();
  const [status, setStatus] = useState<SchedulerStatus | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Проверяем, является ли тренер администратором
  const isAdmin = trainer?.is_admin === true;

  const fetchStatus = async () => {
    // Загружаем статус только для админов
    if (!isAdmin) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      
      const response = await apiService.getSchedulerStatus();
      setStatus(response.status);
    } catch (error) {
      console.error('Error fetching scheduler status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const startScheduler = async () => {
    try {
      const response = await apiService.startScheduler();
      await fetchStatus();
      return response;
    } catch (error) {
      console.error('Error starting scheduler:', error);
      throw error;
    }
  };

  const stopScheduler = async () => {
    try {
      const response = await apiService.stopScheduler();
      await fetchStatus();
      return response;
    } catch (error) {
      console.error('Error stopping scheduler:', error);
      throw error;
    }
  };

  const testNotification = async () => {
    try {
      const response = await apiService.testNotification();
      return response;
    } catch (error) {
      console.error('Error testing notification:', error);
      throw error;
    }
  };

  useEffect(() => {
    fetchStatus();
  }, [isAdmin]);

  return {
    status,
    isLoading,
    startScheduler,
    stopScheduler,
    testNotification,
    refetch: fetchStatus,
  };
}; 